import React, { useState, useEffect, useRef } from "react";

import { Link } from "react-router-dom";

// Translate
import { Translation, useTranslation } from 'react-i18next';

import bgBanner from '../../img/bg/998591.jpg';

function MackerelinNaturalOilwithChili() {
    const { t, i18n } = useTranslation(["translation"]);

    useEffect(() => {
        window.scrollTo(0, 0);

    });

    return (
        <div>
            <section>
                <div className="banner-inter-market" style={{ backgroundImage: `url(${bgBanner})`, backgroundPosition: `top right` }}>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6 col-12">
                                <h3>{t("mackerel.inNaturalOilChili")}</h3>
                                {/* <p>{t("quote.q05")}</p> */}
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="golden-prize-th-tuna-product mb-80">
                <div className="th-tuna-product">
                    <div className="container">
                        <div className="row justify-content-center align-items-center">
                            <div className="col-lg-6 col-md-6 col-11 text-center">
                                <div className="th-tuna-product-premium">
                                    <img src={require("../../img/logo/omega3.svg")} className="pt-5" />
                                </div>
                                <div className="th-tuna-product-item">
                                    <img src={require("../../img/product/goldenprize-mackerel-naturalChili.png")} />
                                    <p>{t("netweight200")}</p>
                                </div>
                            </div>

                            <div className="col-lg-5 col-md-5 col-11">
                                <div className="product-item-Ingredients">
                                    <ul>{t("ingredients.ingredients")}
                                        <li className="ml-5 mt-4">{t("mackerel.mackerel")}</li>  
                                        <li className="ml-5">{t("ingredients.naturalOil")}</li>
                                        <li className="ml-5">{t("ingredients.water")}, {t("ingredients.chili")}, {t("ingredients.salt")}</li>
                                    </ul>
                                </div>

                                <div className="product-item-info">
                                    <h6>{t("ingredients.informationFood")}</h6>
                                    <p>{t("ingredients.fish")}</p>
                                    <h6>{t("nutrition.textDes")}</h6>
                                </div>
                            </div>
                        </div>

                        <div className="row justify-content-center mt-40 mb-80">
                            <div className="col-lg-6 col-md-6 col-11">
                                <div className="performance-facts">
                                    <div className="performance-facts__header">
                                        <h6 className="performance-facts__title">
                                            {t("nutrition.nutrition")}
                                        </h6>
                                        <p>{t("nutrition.servingPer")}: 3</p>
                                        <p>{t("nutrition.servingSize")}: 43g. (1/3 can) {t("nutrition.draninedWeight")}</p>
                                    </div>

                                    <table className="performance-facts__table--small small-info">
                                        <thead>
                                            <tr>
                                                <td colspan="2"></td>
                                                <th>Per serving(43g.)</th>
                                                <th className="pl-4">Per 100 g.</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            <tr>
                                                <th colspan="2"><b>{t("nutrition.energykJ")}</b></th>
                                                <td className="text-right">495 kj</td>
                                                <td className="text-right">1238 kj</td>
                                            </tr>
                                            <tr>
                                                <th colspan="2"><b>{t("nutrition.energykCal")}</b></th>
                                                <td>118.4 kcal</td>
                                                <td>296 kcal</td>
                                            </tr>
                                            <tr>
                                                <th colspan="2"><b>{t("nutrition.protein")}</b></th>
                                                <td>5.3 g</td>
                                                <td>13.3 g</td>
                                            </tr>
                                            <tr>
                                                <th colspan="2"><b>{t("nutrition.carbo")}</b></th>
                                                <td>0 g</td>
                                                <td>0 g</td>
                                            </tr>
                                            <tr>
                                                <th colspan="2"><b>{t("nutrition.fat")}</b></th>
                                                <td>10.8 g</td>
                                                <td>27 g</td>
                                            </tr>
                                            <tr> 
                                                <th colspan="2"><b>{t("nutrition.saturatedFat")}</b></th>
                                                <td>3.2 g</td>
                                                <td>8 g</td>
                                            </tr>
                                            <tr>
                                                <th colspan="2"><b>{t("nutrition.sodium")}</b></th>
                                                <td>0.12 g</td>
                                                <td>0.3 g</td>
                                            </tr>
                                            <tr>
                                                <th colspan="2"><b>{t("nutrition.omega3")}</b></th>
                                                <td>0.22 g</td>
                                                <td>0.55 g</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <p className="bordet-top-table"><b>{t("nutrition.textDes")}</b></p>
                                </div>
                            </div>

                            <div className="col-lg-5 col-md-6 col-11" >
                               
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default MackerelinNaturalOilwithChili;


